<ng-container [ngSwitch]="status">
  <i
    *ngSwitchCase="'ACTIVE'"
    class="bi bi-play-fill text-success fs-1 cursor-pointer"
    (click)="changeStatus.emit(statuses.PAUSED)"
  ></i>
  <i
    *ngSwitchCase="'PAUSED'"
    class="bi bi-pause-fill text-warning fs-1 cursor-pointer"
    (click)="changeStatus.emit(statuses.ACTIVE)"
  ></i>
  <i
    *ngSwitchCase="'DELETED'"
    class="bi bi-x-circle-fill px-1 fs-5 text-danger"
  ></i>
</ng-container>
